/* unplugin-vue-components disabled */import script from "./recommend-dialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./recommend-dialog.vue?vue&type=script&setup=true&lang=ts"

import "./recommend-dialog.vue?vue&type=style&index=0&id=714217ed&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-714217ed"]])

export default __exports__